import { render, staticRenderFns } from "./importAndDownloadExcel.vue?vue&type=template&id=bc0d922c&scoped=true&"
import script from "./importAndDownloadExcel.vue?vue&type=script&lang=js&"
export * from "./importAndDownloadExcel.vue?vue&type=script&lang=js&"
import style0 from "./importAndDownloadExcel.vue?vue&type=style&index=0&id=bc0d922c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0d922c",
  null
  
)

export default component.exports